import {Axios} from '../axios/axios.js'
//group list
//发送消息
export const sendMeaasge = (e) => {
  return Axios({
    url:"/dispatch/send_msg",
    method:'post',
    data:e,
  })
}
//查看消息记录 /chat/get_chat_histroy
export const getChatHistroy = (e) => {
  return Axios({
    url:"/dispatch/get_chat_history",
    method:'post',
    data:e,
  })
}
//是否已读 /chat/read_chat_log
export const readLog = (e) => {
  return Axios({
    url:"/dispatch/read_chat_log",
    method:'post',
    data:e,
  })
}

//上传文件 http://onfleettest.com/upload/upload

export const uploadFile = (e) => {
  return Axios({
    url:"/index.php/upload/upload",
    method:'put',
    data:e,
  })
}
//消息已读
export const readMes = (e) => {
  return Axios({
    url:"/dispatch/read_chat_log",
    method:'put',
    data:e,
  })
}
//获取头部聊天列表 /dispatch/get_header_driver_chat
export const getHeaderDriverList = (e) => {
  return Axios({
    url:"/dispatch/get_header_driver_chat",
    method:'put',
    data:e,
  })
}
//获取左侧所有聊天司机列表 /dispatch/get_chat_driver_list
export const getLeftAllDriverList = (e) => {
  return Axios({
    url:"/dispatch/get_chat_driver_list",
    method:'put',
    data:e,
  })
}
//增加头部聊天司机 /dispatch/add_chat_driver
export const addHeaderDriaverData = (e) => {
  return Axios({
    url:"/dispatch/add_chat_driver",
    method:'put',
    data:e,
  })
}
//删除头部司机 /dispatch/del_chat_driver
export const deleteHeaderDriaverData = (e) => {
  return Axios({
    url:"/dispatch/del_chat_driver",
    method:'put',
    data:e,
  })
}
//播放语音消息
export const playerMsgAudit = (e) => {
  return Axios({
    url:"/dispatch/player_audit",
    method:'put',
    data:e,
  })
}

//修改消息已读
export const readMessage = (e) => {
  return Axios({
    url:"/dispatch/read_log",
    method:'put',
    data:e,
  })
}
